import { action } from 'satcheljs';

/**
 * Action to update the anonymous sharing flag.
 */
let setAnonymousSharingStatus = action(
    'SET_PBP_ANONYMOUS_SHARING_STATUS',
    (isAnonymousSharingEnabled: boolean) => ({
        isAnonymousSharingEnabled,
    })
);

export default setAnonymousSharingStatus;
